import "jquery";
import * as ko from "knockout";
import { BenchmarkViewModel } from "../ViewModels/BenchmarkViewModel";
import { BenchmarkApi } from "../apis/BenchmarkApi";
import { BenchmarkParameter } from "../Models/BenchmarkParameter";
import { Variety } from "../Models/Variety";
import { forEach } from "../../../node_modules/@types/lodash-es/index";

export class Benchmark {
    private benchmarkApi: BenchmarkApi;
    private benchmarkViewModel: BenchmarkViewModel;
    private $benchmark: JQuery;
    private $selectedYear: JQuery;
    private $selectedVarieties: JQuery;
    private $yield: JQuery;
    private $cleaning: JQuery;
    private $byArea: JQuery;
    private $byPostcode: JQuery;
    private $test: JQuery;
    private $area: JQuery;
    private $footable: JQuery;
    private $userZip: JQuery;
    private $areaOptions: JQuery;
    private $settlementAmount: JQuery;
    private beforeYieldPaymentText: string;
    private atLeastOneVarietyText: string;
    private postCodeBeginningLowerThanEndingText: string;


    constructor() {
        this.benchmarkApi = BenchmarkApi.getInstance();
        this.benchmarkViewModel = new BenchmarkViewModel(this.benchmarkApi);
        this.$benchmark = $("#benchmark");
        this.$selectedYear = $("#CropYear");
        this.$selectedVarieties = $("#selectedVarieties");
        this.$yield = $("#Yield");
        this.$cleaning = $("#CleanedSeed");
        this.$byArea = $("#ByArea");
        this.$byPostcode = $("#ByPostcode");
        this.$test = $("#Area");
        this.$area = $("#Area");
        this.$userZip = $("#userZip");
        this.$areaOptions = $("#Area option");
        this.beforeYieldPaymentText = $("#beforeYieldPaymentText").val() as string;
        this.atLeastOneVarietyText = $("#atLeastOneVarietyText").val() as string;
        this.postCodeBeginningLowerThanEndingText = $("#postCodeBeginningLowerThanEndingText").val() as string;

        this.$settlementAmount = $("SettlementAmount");

        if (this.$benchmark[0]) {
            ko.applyBindings(this.benchmarkViewModel, this.$benchmark[0]);
        }
    }

    init(): void {
        this.benchmarkViewModel.init(this.beforeYieldPaymentText, this.atLeastOneVarietyText, this.postCodeBeginningLowerThanEndingText);
        const self = this;

        this.benchmarkApi.getBenchmarkParameters().then((res) => {
            for (var year of res) {
                for (var variety of year.Varieties) {
                    variety.Selected = true;
                }
            }

            this.benchmarkViewModel.parameters(res);
            this.benchmarkViewModel.selectedVarieties(res[0].Varieties);
            this.benchmarkViewModel.selectedParameter(res[0] as any);
            this.benchmarkViewModel.reportType("YieldCleanedMaterial");
            this.onYearUpdate((this.benchmarkViewModel.selectedParameter() as any).Year);
            this.benchmarkViewModel.submit();
        });

        this.$selectedYear.change(() => {
            this.onYearUpdate((this.benchmarkViewModel.selectedParameter() as any).Year);

            let parameter = this.benchmarkViewModel.selectedParameter() as any;
            this.benchmarkViewModel.selectedVarieties(parameter.Varieties);
        });

        this.$selectedVarieties.change(() => {
            console.log(this.benchmarkViewModel.selectedVarieties());
        });

        this.$yield.change(() => {
            self.updateParameter();
        });

        this.$cleaning.change(() => {
            self.updateParameter();
        });

        this.$byArea.change(() => {
            self.updateArea();
        });

        this.$byPostcode.change(() => {
            self.updateArea();
        });

        this.$area.change(() => {
            self.updateAreaRange();
        });

        this.benchmarkViewModel.areaSelected.subscribe(function(areaSelected) {
            if (areaSelected) {
                self.updateAreaRange();
            }
        });
        this.initialSelectedArea();
    }

    private onYearUpdate(year: number) {
        let dateNow = new Date();
        let terminalDate = new Date(year + 1, 5, 9, 0, 0, 0, 0);

        if (dateNow > terminalDate) {
            this.benchmarkViewModel.disableYieldPayment(false);
        } else {
            this.benchmarkViewModel.disableYieldPayment(true);

            if (this.benchmarkViewModel.reportType() == "YieldPayment") {
                this.benchmarkViewModel.reportType("YieldCleanedMaterial");
            }
        }
    }

    private updateAreaRange(): void {
        let areaRange = this.benchmarkViewModel.selectedAreaRange().split(",");
        this.benchmarkViewModel.postcodeBegin(areaRange[0]);
        this.benchmarkViewModel.postcodeEnd(areaRange[1]);
    }

    private updateParameter(): void {
        this.delay(1).then(() => {
            if (this.benchmarkViewModel.benchmarkType() == "yield") {
                this.benchmarkViewModel.yieldSelected(true);
                this.benchmarkViewModel.cleaningSelected(false);
                this.benchmarkViewModel.reportType("YieldCleanedMaterial");
            } else if (this.benchmarkViewModel.benchmarkType() == "cleaning") {
                this.benchmarkViewModel.yieldSelected(false);
                this.benchmarkViewModel.cleaningSelected(true);
                this.benchmarkViewModel.reportType("CleaningWaste");
            }
        });
    }

    private updateArea(): void {
        this.delay(1).then(() => {
            if (this.benchmarkViewModel.areaType() == "ByArea") {
                this.benchmarkViewModel.areaSelected(true);
                this.benchmarkViewModel.postcodeSelected(false);
            } else if (this.benchmarkViewModel.areaType() == "ByPostcode") {
                this.benchmarkViewModel.areaSelected(false);
                this.benchmarkViewModel.postcodeSelected(true);
            }
        });


    }

    private delay(ms: number) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    private initialSelectedArea(): void {
        var self = this;
        const zip = Number.parseInt(this.$userZip.text());
        if (zip) {
            this.$areaOptions.each(function () {
                //$(this) is the object in the function scope, not the class.
                const value = ($(this as any).val() as string);
                const values = value.split(",");
                const low = Number.parseInt(values[0]);
                const high = Number.parseInt(values[1]);
                if (zip >= low && zip <= high) {
                    $(this as any).prop("selected", true);
                    self.benchmarkViewModel.selectedAreaRange(value);
                    self.updateAreaRange();
                }
            });
        }
    }
}